import { Config } from '../config/config.es6';

export default class Top {
    constructor() {
        this.booksData = null;
        this.levelList = ['j1q', '2q', 'j2p', 'j2q', '3q', '4q', '5q'];
    }

    async getBooksData() {
        const booksUrl = Config.booksFile;
        const booksResponse = await fetch(booksUrl);
        this.booksData = await booksResponse.json();
    }

    getEachBooksData(level) {
        return this.booksData.filter((elm) => elm.level === level);
    }
    
    getRebuildBooksData() {
        const rebuildBookDataArr = [];

        // 級ごとに、重複を取り除いた書籍の配列を生成
        // filenameも入ってくるが使用しない
        this.levelList.forEach((level) => {
            const arr = [...new Map(this.getEachBooksData(level).map((v) => [v.contents_code, v])).values()];
            rebuildBookDataArr.push(arr);
        });

        return rebuildBookDataArr;
    }
}
